import css from './rivermax.module.scss';
import OverView from './components/OverView';
import { useGlobal } from '@/utils/useGlobal';
import { LineSpace } from '@/componentsH5/ProductComponents';
import { BannerModule, TextWithImage } from '@/componentsH5/ProductDetailComponents';
import { EFACCharging, EFCCharging, EFSCharging } from '@/components/UI/svg/ProductStatic';
import MultiSellPointsThirdModule from '@/componentsH5/ProductDetailComponents/MultiSellPointsModule/First';
import { getDetaileMoreProducts } from '@/utils';
import { getImageLocal, getImageSpec } from '@/utils/locals';
import OtherList from '@/components/ProductCommon/OtherList';
import AppPointRiverBase from '@/components/AppPoint/RiverBaseH5';
import { SHOW_APP_POINT_SITES } from '@/constants';

export default function RiverMax() {
    const { gloproductlist, useLang, useRouter, Link } = useGlobal();
    const { t } = useLang('rivermaxportablepowerstation');
    const { locale } = useRouter();
    const imgSpec = getImageSpec(locale, ['au', 'uk', 'cn', 'de', 'fr', 'es', 'it', 'eu', 'za']);
    const appImgLocal = getImageLocal(locale, ['jp', 'de', 'fr', 'cn']);
    const webpUrl = '/media/rivermax/h5/';
    const banner_items = [
        {
            bgImgs: [`rivermax_banner_h5_${imgSpec}.webp`, `rivermax_banner_h5_${imgSpec}.jpg`],
            title: t('river_max.banner_title'),
            des: t('river_max.banner'),
        },
    ];
    const textWithImgItem1 = {
        title: t('river_max.capacity'),
        synopsis: t('river_max.capacity_sub_title'),
        desc: t('river_max.capacity_desc'),
        img_url: [`rivermax1_h5_${imgSpec}.webp`, `rivermax1_h5_${imgSpec}.jpg`],
    };
    const textWithImgItem2 = {
        title: t('river_max.AC_output'),
        synopsis: t('river_max.AC_output_sub_title'),
        desc: t.rich('river_max.AC_output_desc', {
            line1: (text: string) => (
                <Link className="ef-link__page is-mobile" href="/x-boost" newWin>
                    {text}
                </Link>
            ),
        }),
        noUseHtmlAttr: true,
        img_url: ['rivermax2_h5.webp', 'rivermax2_h5.jpg'],
        arr: [
            { num: '600', eum: 'w', desc: t('river_max.AC_output_desc1') },
            {
                num: locale === 'jp' ? '1200' : '1800',
                eum: 'w',
                desc: t('river_max.AC_output_desc2'),
            },
        ],
    };
    const textWithImgItem3 = {
        title: t('river_max.battery_system'),
        synopsis: t('river_max.battery_system_sub_title'),
        desc: t('river_max.battery_system_desc'),
        img_url: ['rivermax3_h5.webp', 'rivermax3_h5.jpg'],
    };
    const textWithImgItem4 = {
        title: t('river_max.app_support'),
        synopsis: t('river_max.app_support_sub_title'),
        desc: t('river_max.app_support_desc'),
        img_url: [`rivermax4_h5_${appImgLocal}.webp`, `rivermax4_h5_${appImgLocal}.jpg`],
    };
    const textWithImgItem5 = {
        title: t('river_max.plus'),
        synopsis: t('river_max.plus_sub_title'),
        desc: t('river_max.plus_desc'),
        img_url: ['rivermax5_h5.webp', 'rivermax5_h5.jpg'],
    };
    const sellPoints = [
        {
            icon: <EFACCharging />,
            title: t('river_max.charging_title1'),
            des: t('river_max.charging_desc1'),
            directUrl: '/',
        },
        {
            icon: <EFSCharging />,
            title: t('river_max.charging_title2'),
            des: t('river_max.charging_desc2'),
            directUrl: '/',
        },
        {
            icon: <EFCCharging />,
            title: t('river_max.charging_title3'),
            des: t('river_max.charging_desc3'),
            directUrl: '/',
        },
    ];

    const product: any = {
        us: ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'],
        za: ['product_ps_river_river', 'product_ps_river_river_pro_720'],
    };
    const otherProduct = getDetaileMoreProducts(gloproductlist, product[locale] || product.us);

    return (
        <div className={`${css.animationWrapper}`}>
            <div style={{ width: '100%' }}>
                <BannerModule
                    config={{
                        position: 'top',
                        theme: 'black',
                        webpUrl,
                    }}
                    data={banner_items}
                />
            </div>
            {/* 新版本一图看懂 */}
            <OverView></OverView>
            <LineSpace height={0.8} background="#fff" />
            <div className="text-image">
                <TextWithImage config={{ position: 'top', text: 'left', descColor: '#222', fullScreen: false, webpUrl }} data={textWithImgItem1} />
            </div>
            <LineSpace height={1.2} background="#fff" />
            <div className="text-image textWithImgItem2">
                <TextWithImage config={{ position: 'top', text: 'left', descColor: '#222', fullScreen: false, webpUrl }} data={textWithImgItem2} />
            </div>
            <LineSpace height={1.2} background="#fff" />
            {
                <MultiSellPointsThirdModule
                    data={{
                        items: sellPoints,
                        desc: { text: '' },
                        guide: { text: t('river_max.charging') },
                        title: { text: t('river_max.charging_desc') },
                    }}
                    cssStyle={{
                        guideStyle: { color: 'rgb(38, 115, 255)' },
                        titleStyle: { lineHeight: '.34rem' },
                        textIconStyle: {
                            wrapperBackColor: 'transparent',
                            wrapperPadding: 0,
                            wrapperHeight: '2rem',
                            wrapperBorderRadius: '0.1rem',
                            wrapperMargin: 0,
                        },
                    }}
                />
            }
            {locale === 'jp' && <div className="SellPointsThird-desc">{t('river_max.charging_desc2_*')}</div>}
            <LineSpace height={1.2} background="#fff" />
            <div className="text-image textWithImgItem3">
                <TextWithImage config={{ position: 'bottom', text: 'center', descColor: '#222', webpUrl }} data={textWithImgItem3} />
            </div>
            <LineSpace height={1.2} background="#fff" />
            {!SHOW_APP_POINT_SITES.includes(locale) && (
                <div className="text-image textWithImgItem4">
                    <TextWithImage config={{ position: 'top', text: 'left', descColor: '#222', webpUrl }} data={textWithImgItem4} />
                </div>
            )}
            {SHOW_APP_POINT_SITES.includes(locale) && <AppPointRiverBase />}
            <LineSpace height={1.2} background="#fff" />
            <section className="RIVER-Max-Plus">
                <TextWithImage config={{ position: 'top', fullScreen: false, text: 'left', descColor: '#222', webpUrl }} data={textWithImgItem5} />
                <LineSpace height={1.2} background="#fff" />
            </section>
            <div className="container">
                <OtherList data={otherProduct} />
            </div>
        </div>
    );
}
